import { useState, useEffect } from "react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="גלול למעלה"
      className="fixed bottom-44 left-4 z-50 w-12 h-12 flex items-center justify-center rounded-full border-[2.5px] border-gray-900 cursor-pointer transition-all duration-300 hover:scale-110"
      style={{
        background: "#FAF9F6",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transform: visible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 0.3s ease, transform 0.3s ease",
      }}
    >
      <i className="ri-arrow-up-line text-gray-900 text-xl"></i>
    </button>
  );
}
